
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref85b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref85b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2lB2g", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $1b5a45679bee7e01$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $1b5a45679bee7e01$export$5f0017c582d45a2d; });
function $1b5a45679bee7e01$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("8EGc6", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $64d2ca0b63cc36d2$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $64d2ca0b63cc36d2$export$1e71eb4bef00f6b0; });
function $64d2ca0b63cc36d2$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("gpGF7", function(module, exports) {

$parcel$export(module.exports, "addItemtoDatabase", function () { return $bf3012f26aea2752$export$82f40b3dcec5fdbf; });
$parcel$export(module.exports, "getAllItemsFromDatabase", function () { return $bf3012f26aea2752$export$32ed9b603c1c0fba; });
$parcel$export(module.exports, "deleteItemFromDatabase", function () { return $bf3012f26aea2752$export$93b0377360880ace; });
$parcel$export(module.exports, "deleteMultipleItemsFromDatabase", function () { return $bf3012f26aea2752$export$1d46c37b4dca7572; });
$parcel$export(module.exports, "getObjectStoreLength", function () { return $bf3012f26aea2752$export$f6d7fed6eef7925; });
$parcel$export(module.exports, "updateItemInDatabase", function () { return $bf3012f26aea2752$export$85414c0f46549544; });
$parcel$export(module.exports, "getItemValueFromDatabase", function () { return $bf3012f26aea2752$export$402fb77fcd6136b6; });

var $e2996 = parcelRequire("e2996");

var $gAasq = parcelRequire("gAasq");
var $bf3012f26aea2752$var$DatabaseManager = function() {
    var instance;
    function createInstance() {
        var dbName = "TaskFlow";
        var dbVersion = 1;
        return new Promise(function(resolve, reject) {
            var request = indexedDB.open(dbName, dbVersion);
            request.onupgradeneeded = function(event) {
                var db = event.target.result;
                createObjectStores(db);
            };
            request.onsuccess = function(event) {
                var db = event.target.result;
                resolve(db);
            };
            request.onerror = function(event) {
                reject(event.target.error);
            };
        });
    }
    function createObjectStores(db) {
        if (!db.objectStoreNames.contains("notes")) {
            var notesStore = db.createObjectStore("notes", {
                keyPath: "id"
            });
            notesStore.createIndex("id", "id", {
                unique: true
            });
            notesStore.createIndex("title", "title", {
                unique: false
            });
            notesStore.createIndex("description", "description", {
                unique: false
            });
            notesStore.createIndex("tag", "tag", {
                unique: false
            });
            notesStore.createIndex("favorited", "favorited", {
                unique: false
            });
            notesStore.createIndex("date", "date", {
                unique: false
            });
        }
        if (!db.objectStoreNames.contains("event")) {
            var eventStore = db.createObjectStore("event", {
                keyPath: "id"
            });
            eventStore.createIndex("id", "id", {
                unique: true
            });
            eventStore.createIndex("title", "title", {
                unique: false
            });
            eventStore.createIndex("start", "start", {
                unique: false
            });
            eventStore.createIndex("end", "end", {
                unique: false
            });
            eventStore.createIndex("extendedprops", "extendedprops", {
                unique: false
            });
            eventStore.createIndex("url", "url", {
                unique: false
            });
        }
        if (!db.objectStoreNames.contains("todo")) {
            var toDoStore = db.createObjectStore("todo", {
                keyPath: "id"
            });
            toDoStore.createIndex("id", "id", {
                unique: true
            });
            toDoStore.createIndex("title", "title", {
                unique: false
            });
            toDoStore.createIndex("description", "description", {
                unique: false
            });
            toDoStore.createIndex("priority", "priority", {
                unique: false
            });
            toDoStore.createIndex("important", "important", {
                unique: false
            });
            toDoStore.createIndex("completed", "completed", {
                unique: false
            });
            toDoStore.createIndex("trash", "trash", {
                unique: false
            });
            toDoStore.createIndex("date", "date", {
                unique: false
            });
        }
        if (!db.objectStoreNames.contains("scrumboard")) {
            var scrumStore = db.createObjectStore("scrumboard", {
                keyPath: "id"
            });
            scrumStore.createIndex("id", "id", {
                unique: true
            });
            scrumStore.createIndex("title", "title", {
                unique: false
            });
            scrumStore.createIndex("description", "description", {
                unique: false
            });
            scrumStore.createIndex("tasksection", "tasksection", {
                unique: false
            });
            scrumStore.createIndex("order", "order", {
                unique: false
            });
            scrumStore.createIndex("progress", "progress", {
                unique: false
            });
            scrumStore.createIndex("date", "date", {
                unique: false
            });
        }
        if (!db.objectStoreNames.contains("scrumlist")) {
            var scrumList = db.createObjectStore("scrumlist", {
                keyPath: "id"
            });
            var timestamp = new Date().getTime();
            scrumList.createIndex("id", "id", {
                unique: true
            });
            scrumList.createIndex("title", "title", {
                unique: false
            });
            scrumList.createIndex("order", "order", {
                unique: false
            });
            scrumList.createIndex("timestamp", "timestamp", {
                unique: false
            });
            var initialContainerOrders = [
                {
                    id: "s-new",
                    title: "New",
                    order: 0,
                    timestamp: timestamp
                },
                {
                    id: "s-in-progress",
                    title: "In Progress",
                    order: 1,
                    timestamp: timestamp
                },
                {
                    id: "s-complete",
                    title: "Complete",
                    order: 2,
                    timestamp: timestamp
                }
            ];
            initialContainerOrders.forEach(function(orderData) {
                scrumList.add(orderData);
            });
        }
    }
    return {
        getInstance: function getInstance() {
            if (!instance) instance = createInstance();
            return instance;
        }
    };
}();
var $bf3012f26aea2752$export$82f40b3dcec5fdbf = function() {
    var _ref = (0, $e2996._)(function(data, objectStoreName) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    if (!data.timestamp) data.timestamp = new Date().getTime();
                    else if (typeof data.timestamp === "string") data.timestamp = new Date(data.timestamp).getTime();
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readwrite");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            var request = objectStore.add(data);
                            request.onsuccess = function(event) {
                                resolve(data);
                            };
                            request.onerror = function(event) {
                                console.error("Error adding item:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function addItemtoDatabase(data, objectStoreName) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$32ed9b603c1c0fba = function() {
    var _ref = (0, $e2996._)(function(objectStoreName, filterFunction) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readonly");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            var items = [];
                            var request = objectStore.openCursor();
                            request.onsuccess = function(event) {
                                var cursor = event.target.result;
                                if (cursor) {
                                    // Check if filtering is enabled and filter by container if necessary
                                    if (!filterFunction || filterFunction(cursor.value)) items.push(cursor.value);
                                    cursor["continue"]();
                                } else resolve(items);
                            };
                            request.onerror = function(event) {
                                console.error("Error getting items:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getAllItemsFromDatabase(objectStoreName, filterFunction) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$249f3d852e627de1 = function() {
    var _ref = (0, $e2996._)(function(id, objectStoreName) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readonly");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            var request = objectStore.get(id);
                            request.onsuccess = function(event) {
                                var result = event.target.result;
                                resolve(result);
                            };
                            request.onerror = function(event) {
                                console.error("Error getting item:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getItemFromDatabase(id, objectStoreName) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$93b0377360880ace = function() {
    var _ref = (0, $e2996._)(function(objectId, objectStoreName) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readwrite");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            var request = objectStore["delete"](objectId);
                            request.onsuccess = function(e) {
                                resolve(true);
                            };
                            request.onerror = function(e) {
                                console.error("Error getting item:", e.target.error);
                                reject(e.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteItemFromDatabase(objectId, objectStoreName) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$1d46c37b4dca7572 = function() {
    var _ref = (0, $e2996._)(function(objectIds, objectStoreName) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readwrite");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        Promise.all(objectIds.map(function(objectId) {
                            return new Promise(function(resolve, reject) {
                                var request = objectStore["delete"](objectId);
                                request.onsuccess = function(e) {
                                    resolve(true);
                                };
                                request.onerror = function(e) {
                                    console.error("Error deleting item:", e.target.error);
                                    reject(e.target.error);
                                };
                            });
                        }))
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function deleteMultipleItemsFromDatabase(objectIds, objectStoreName) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$f6d7fed6eef7925 = function() {
    var _ref = (0, $e2996._)(function(objectStoreName) {
        var db, transaction, objectStore, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readonly");
                    objectStore = transaction.objectStore(objectStoreName);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            var request = objectStore.openCursor();
                            var count = 0;
                            request.onsuccess = function(event) {
                                var cursor = event.target.result;
                                if (cursor) {
                                    count++;
                                    cursor["continue"]();
                                } else resolve(count);
                            };
                            request.onerror = function(event) {
                                console.error("Error counting items:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getObjectStoreLength(objectStoreName) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$85414c0f46549544 = function() {
    var _ref = (0, $e2996._)(function(id, objectStoreName, newData) {
        var db, transaction, objectStore, request, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    newData.isEdited = true;
                    newData.timestamp = new Date().getTime();
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readwrite");
                    objectStore = transaction.objectStore(objectStoreName);
                    request = objectStore.get(id);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            request.onsuccess = function(event) {
                                var existingData = event.target.result;
                                var dataChanged = false;
                                for(var property in newData)if (newData.hasOwnProperty(property) && existingData[property] !== newData[property]) {
                                    existingData[property] = newData[property];
                                    // console.log(existingData[property]);
                                    dataChanged = true;
                                }
                                if (dataChanged) {
                                    var updateRequest = objectStore.put(existingData);
                                    updateRequest.onsuccess = function() {
                                        // console.log('Item updated successfully:', existingData);
                                        resolve(existingData);
                                    };
                                    updateRequest.onerror = function(event) {
                                        console.error("Error updating item:", event.target.error);
                                        reject(event.target.error);
                                    };
                                } else resolve(existingData);
                            };
                            request.onerror = function(event) {
                                console.error("Error getting item to update:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function updateItemInDatabase(id, objectStoreName, newData) {
        return _ref.apply(this, arguments);
    };
}();
var $bf3012f26aea2752$export$402fb77fcd6136b6 = function() {
    var _ref = (0, $e2996._)(function(id, property, objectStoreName) {
        var db, transaction, objectStore, request, err;
        return (0, $gAasq.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        $bf3012f26aea2752$var$DatabaseManager.getInstance()
                    ];
                case 1:
                    db = _state.sent();
                    transaction = db.transaction([
                        objectStoreName
                    ], "readonly");
                    objectStore = transaction.objectStore(objectStoreName);
                    request = objectStore.get(id);
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            request.onsuccess = function(event) {
                                var existingData = event.target.result;
                                if (existingData && existingData.hasOwnProperty(property)) // console.log(existingData[property]);
                                resolve(existingData[property]);
                                else resolve(null);
                            };
                            request.onerror = function(event) {
                                console.error("Error getting item value:", event.target.error);
                                reject(event.target.error);
                            };
                        })
                    ];
                case 2:
                    err = _state.sent();
                    throw err;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getItemValueFromDatabase(id, property, objectStoreName) {
        return _ref.apply(this, arguments);
    };
}(); //Delete Database
 // const dbName = 'TaskFlow';
 // const request = indexedDB.open(dbName);
 // request.onsuccess = function (event) {
 //   const db = event.target.result;
 //   db.close();
 //   deleteDatabase();
 // };
 // const deleteDatabase = function () {
 //   const dbName = 'TaskFlow';
 //   const request = indexedDB.deleteDatabase(dbName);
 //   request.onsuccess = function (event) {
 //     console.log('Database deleted successfully!');
 //   };
 //   request.onerror = function (event) {
 //     console.error('Error deleting database:', event.target.error);
 //   };
 // };
 // const dbName = 'TaskFlow';
 // const Dbversion = 1;
 // const storeNameToDelete = 'scrumboard';
 // const request = indexedDB.open(dbName, Dbversion);
 // request.onupgradeneeded = function (event) {
 //   const db = event.target.result;
 //   if (db.objectStoreNames.contains(storeNameToDelete)) {
 //     db.deleteObjectStore(storeNameToDelete);
 //   }
 // };
 // request.onsuccess = function (event) {
 //   console.log('Object store deleted successfully.');
 // };
 // request.onerror = function (event) {
 //   console.error('Error deleting object store:', event.target.error);
 // };

});
parcelRegister("e2996", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a37858c721279338$export$7c398597f8905a1; });
function $a37858c721279338$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $a37858c721279338$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $a37858c721279338$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $a37858c721279338$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("gAasq", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $c1281ec2e4f7c38e$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $c1281ec2e4f7c38e$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $2lB2g = parcelRequire("2lB2g");
var $c1281ec2e4f7c38e$var$extendStatics = function extendStatics1(d, b) {
    $c1281ec2e4f7c38e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c1281ec2e4f7c38e$var$extendStatics(d, b);
};
function $c1281ec2e4f7c38e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c1281ec2e4f7c38e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c1281ec2e4f7c38e$export$18ce0697a983be9b = function __assign1() {
    $c1281ec2e4f7c38e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c1281ec2e4f7c38e$export$18ce0697a983be9b.apply(this, arguments);
};
function $c1281ec2e4f7c38e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c1281ec2e4f7c38e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c1281ec2e4f7c38e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c1281ec2e4f7c38e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c1281ec2e4f7c38e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c1281ec2e4f7c38e$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $2lB2g._)(x)) === "symbol" ? x : "".concat(x);
}
function $c1281ec2e4f7c38e$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $2lB2g._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c1281ec2e4f7c38e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c1281ec2e4f7c38e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c1281ec2e4f7c38e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c1281ec2e4f7c38e$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c1281ec2e4f7c38e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c1281ec2e4f7c38e$export$45d3717a4c69092e(o, m, p);
}
function $c1281ec2e4f7c38e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c1281ec2e4f7c38e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c1281ec2e4f7c38e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c1281ec2e4f7c38e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c1281ec2e4f7c38e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c1281ec2e4f7c38e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c1281ec2e4f7c38e$export$10c90e4f7922046c(v) {
    return this instanceof $c1281ec2e4f7c38e$export$10c90e4f7922046c ? (this.v = v, this) : new $c1281ec2e4f7c38e$export$10c90e4f7922046c(v);
}
function $c1281ec2e4f7c38e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c1281ec2e4f7c38e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c1281ec2e4f7c38e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c1281ec2e4f7c38e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c1281ec2e4f7c38e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c1281ec2e4f7c38e$export$19a8beecd37a4c45 === "function" ? $c1281ec2e4f7c38e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c1281ec2e4f7c38e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c1281ec2e4f7c38e$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $c1281ec2e4f7c38e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c1281ec2e4f7c38e$export$45d3717a4c69092e(result, mod, k);
    }
    $c1281ec2e4f7c38e$var$__setModuleDefault(result, mod);
    return result;
}
function $c1281ec2e4f7c38e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $c1281ec2e4f7c38e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c1281ec2e4f7c38e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c1281ec2e4f7c38e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c1281ec2e4f7c38e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c1281ec2e4f7c38e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c1281ec2e4f7c38e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c1281ec2e4f7c38e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $c1281ec2e4f7c38e$export$2e2bcd8739ae039 = {
    __extends: $c1281ec2e4f7c38e$export$a8ba968b8961cb8a,
    __assign: $c1281ec2e4f7c38e$export$18ce0697a983be9b,
    __rest: $c1281ec2e4f7c38e$export$3c9a16f847548506,
    __decorate: $c1281ec2e4f7c38e$export$29e00dfd3077644b,
    __param: $c1281ec2e4f7c38e$export$d5ad3fd78186038f,
    __metadata: $c1281ec2e4f7c38e$export$f1db080c865becb9,
    __awaiter: $c1281ec2e4f7c38e$export$1050f835b63b671e,
    __generator: $c1281ec2e4f7c38e$export$67ebef60e6f28a6,
    __createBinding: $c1281ec2e4f7c38e$export$45d3717a4c69092e,
    __exportStar: $c1281ec2e4f7c38e$export$f33643c0debef087,
    __values: $c1281ec2e4f7c38e$export$19a8beecd37a4c45,
    __read: $c1281ec2e4f7c38e$export$8d051b38c9118094,
    __spread: $c1281ec2e4f7c38e$export$afc72e2116322959,
    __spreadArrays: $c1281ec2e4f7c38e$export$6388937ca91ccae8,
    __spreadArray: $c1281ec2e4f7c38e$export$1216008129fb82ed,
    __await: $c1281ec2e4f7c38e$export$10c90e4f7922046c,
    __asyncGenerator: $c1281ec2e4f7c38e$export$e427f37a30a4de9b,
    __asyncDelegator: $c1281ec2e4f7c38e$export$bbd80228419bb833,
    __asyncValues: $c1281ec2e4f7c38e$export$e3b29a3d6162315f,
    __makeTemplateObject: $c1281ec2e4f7c38e$export$4fb47efe1390b86f,
    __importStar: $c1281ec2e4f7c38e$export$c21735bcef00d192,
    __importDefault: $c1281ec2e4f7c38e$export$da59b14a69baef04,
    __classPrivateFieldGet: $c1281ec2e4f7c38e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c1281ec2e4f7c38e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c1281ec2e4f7c38e$export$81fdc39f203e4e04,
    __addDisposableResource: $c1281ec2e4f7c38e$export$88ac25d8e944e405,
    __disposeResources: $c1281ec2e4f7c38e$export$8f076105dc360e92
};

});



//# sourceMappingURL=scrumboard.db60b62a.js.map
